import mutations from './mutations.js';
import actions from './actions.js';
import getters from './getters.js';

export default {
  state() {
    let user = null;
    try {
      user = JSON.parse(localStorage.getItem("user") || "null");
    } catch {
      user = null;
    }

    return {
      user,
      token: localStorage.getItem("token"),
    };
  },
  mutations,
  actions,
  getters,
  namespaced: false
};
